import React from 'react';
import { Bar } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

interface OccupancyChartProps {
  data: { occupied_units: number; total_units: number };
}

const OccupancyChart: React.FC<OccupancyChartProps> = ({ data }) => {
  const occupiedUnits = data?.occupied_units || 0;
  const totalUnits = data?.total_units || 0;
  const occupancyRate = totalUnits > 0 ? (occupiedUnits / totalUnits) * 100 : 0;

  const chartData = {
    labels: ['Occupancy Rate'],
    datasets: [
      {
        label: 'Occupancy Rate',
        data: [occupancyRate],
        backgroundColor: '#0F9D58', // Normal Green
        borderColor: '#0F9D58', // Normal Green
        borderWidth: 1,
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: 'top' as const,
      },
      title: {
        display: true,
        text: 'Current Occupancy Rate',
      },
    },
    scales: {
      y: {
        beginAtZero: true,
        max: 100,
        title: {
          display: true,
          text: 'Percentage (%)',
        },
      },
    },
  };

  return (
    <div className="h-72 w-full">
      <Bar data={chartData} options={options} />
    </div>
  );
};

export default OccupancyChart;
